import React, {Fragment} from 'react';
import PrivacyPolicyPage from '../policy/privacy-policy';
import Navbar from '../nav-bar/nav-bar';
import './privacy-policy.scss';

export default function (props) {
    return(
        <Fragment>
            <div id={'privacy-policy'}>
                <Navbar/>
                <h2>Privacy Policy</h2>
                <PrivacyPolicyPage/>
            </div>
        </Fragment>
       
    );
}
 